(() => {
  'use strict';
  const key = 'glassique:shopping-intent:207506669902';
  let shopping = document.documentElement.classList.contains('gq-shopping-intent');
  let queued = false;
  try { shopping = shopping || sessionStorage.getItem(key) === '1'; } catch (_) {}
  shopping = shopping || /\/(cart|checkouts?)(\/|$)/.test(location.pathname);
  function suppress() {
    if (!shopping) return;
    document.documentElement.classList.add('gq-shopping-intent');
    const host = document.querySelector('#app-embed-container-458869');
    const close = host?.shadowRoot?.querySelector('[aria-label="Close modal"]');
    if (close) close.click();
  }
  function intent() {
    shopping = true;
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
    suppress();
  }
  function inspect() {
    queued = false;
    if (document.querySelector('cart-drawer[open], cart-drawer[aria-hidden="false"]')) intent();
    else suppress();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(inspect);
  }
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('#custom-button-A, #custom-button-B, [data-gq-purchase-add], [data-gq-purchase-cod]')) intent();
    const link = target.closest('a[href]');
    if (link && /\/(cart|checkouts?)(\/|\?|$)/.test(link.getAttribute('href') || '')) intent();
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && /\/cart\/add/.test(form.action)) intent();
  }, true);
  ['product:added', 'cart:change', 'cart:refresh'].forEach((name) => document.addEventListener(name, intent));
  document.addEventListener('dialog:after-show', (event) => {
    if (event.target instanceof Element && event.target.matches('cart-drawer')) intent();
  });
  function start() {
    inspect();
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
